import { createContext } from 'react';

export interface CheckboxListContextType<TValue = never> {
  disabled?: boolean;
  isChecked: (value: TValue) => boolean;
  name: string;
  toggleChecked: (value: TValue) => void;
}

export const CheckboxListContext = createContext<CheckboxListContextType>(
  {} as CheckboxListContextType
);
